import { call, put } from 'redux-saga/effects';
import { ApiResponse } from 'apisauce';
import { HealAPI } from '../../healApi';
import { setUserAccountId, setAccount } from './actions';
import { Account } from './types';

export function* getActiveUser() {
  const result: ApiResponse<Account> = yield call(HealAPI.fetchCurrentAccount);
  if (result.ok && result.data) {
    yield put(setAccount(result.data));
    yield put(setUserAccountId(result.data.userAccountId));
  }
}
